var useComboboxStyle = function useComboboxStyle(_ref) {
  var size = _ref.size,
      focus = _ref.focus;
  var wrapperStyle = {
    alignItems: 'items-center',
    boxShadow: 'focus-within:shadow-outline-blue',
    borderColor: focus ? 'border-blue-300' : 'border-gray-200',
    padding: size === 'sm' ? ['px-1', 'py-0.5'] : ['px-3', 'py-1'],
    gap: 'gap-x-1.5'
  };
  var inputStyle = {
    textColor: 'text-gray-600',
    borderWidth: 'border-0',
    boxShadow: 'focus:shadow-none',
    display: 'block',
    flexGrow: 'flex-grow',
    padding: ['px-2', 'py-0'],
    margin: size === 'sm' ? 'my-0.5' : 'my-1',
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    lineHeight: size === 'sm' ? 'leading-5' : 'leading-6'
  };
  var tagStyle = {
    backgroundColor: 'bg-gray-100',
    borderRadius: 'rounded',
    padding: 'pl-2',
    margin: 'my-1',
    alignItems: 'items-center',
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    lineHeight: size === 'sm' ? 'leading-5' : 'leading-6',
    height: size === 'sm' ? 'h-5' : 'h-6'
  };
  var tagIconStyle = {
    icon: 'small-close',
    label: 'close',
    appearance: 'ghost',
    padding: ['px-1', 'py-0'],
    margin: 'ml-1',
    backgroundColor: 'hover:bg-gray-300',
    width: size === 'sm' ? 'w-5' : 'w-6',
    height: size === 'sm' ? 'h-5' : 'h-6',
    textColor: 'text-black'
  };
  var inputIconStyle = {
    appearance: 'ghost',
    padding: 'p-0',
    backgroundColor: 'bg-transparent',
    width: size === 'sm' ? 'w-5' : 'w-6',
    textColor: focus ? ['text-gray-600', 'hover:text-black'] : ['text-gray-300', 'hover:text-gray-500']
  };
  return {
    wrapperStyle: wrapperStyle,
    inputStyle: inputStyle,
    tagStyle: tagStyle,
    tagIconStyle: tagIconStyle,
    inputIconStyle: inputIconStyle
  };
};

export { useComboboxStyle };
//# sourceMappingURL=use-combobox-style.esm.js.map
